<template>
  <div class="main">
    <secondHeader />
    <div class="des">
      <p>URLをコピー→OBSでブラウザソースを追加しURLを貼り付け→タイマー部分をトリミングして使ってください</p>
      <p>ウィンドウサイズによってタイマーは改行されます。いい感じのサイズに調整してみてください。</p>
      <p>背景は透明にしているので、幅広く使えます。</p>
    </div>
    <div id="timer">
      <p class="text">2023年終了まで</p>
      <p class="time">{{ countDown }}</p>
      <p v-if="countDown < '0'" class="end">あけましておめでとう</p>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import "moment-duration-format";
import secondHeader from "../components/secondHeader.vue";

export default {
  name: "app",
  components: {
    secondHeader,
  },
  data() {
    return {
      countDown: "",
    };
  },
  mounted() {
    setInterval(() => {
      //一秒間に一回再取得
      // diffメソッドを使って、日時の差を、ミリ秒で取得
      const diff = moment("2024-01-01").diff(moment());
      // ミリ秒からdurationオブジェクトを生成
      const duration = moment
        .duration(diff)
        .format(
          [
            moment.duration("second"),
            moment.duration("minute"),
            moment.duration("hour"),
          ],
          "d[days] hh:mm:ss"
        );
      //カウントダウンの結果を変数に代入
      this.countDown = duration;
    }, 1000);
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Share+Tech+Mono&display=swap");
.main{
  height: 120vh;
  line-height: 1;
  max-width: 767px;
  margin: 0 auto;
}
p {
  margin: 0;
  padding: 0;
}
.des{
  max-width: 514px;
  margin: 48px auto 72px auto;
  text-align: center;
}
.des p{
  font-size: 14px;
  letter-spacing: 2px;
  margin: 5px 0;
}
#timer {
  margin-top:48px;
  background-color: rgba(0, 0, 0, 0);
  text-align: center;
  max-width: 767px;
  margin: 0 auto;
  /* text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0); */
}
.end {
  color: #89c3eb;
  background: #ecf3ff;
  letter-spacing: 0.05em;
  font-size: 24px;
  padding: 5px 0;
  margin: 0;
  padding: 0;
  animation-name: fadeIn;
  animation-fill-mode: both;
  animation-delay: 2s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.time {
  font-family: "Share Tech Mono", monospace;
  color: #89c3eb;
  letter-spacing: 0.05em;
  font-size: 80px;
  padding: 5px 0;
  margin: 0;
  padding: 0;
}
.text {
  letter-spacing: 0.3em;
  font-size: 24px;
  font-weight: bold;
  margin: 48px auto;
  padding: 0;
  text-shadow: 1px 1px 0 #fff, -1px -1px 0 #fff, -1px 1px 0 #fff,
    1px -1px 0 #fff, 0px 1px 0 #fff, 0-1px 0 #fff, -1px 0 0 #fff, 1px 0 0 #fff;
}
.copy {
  letter-spacing: 0.1em;
  font-size: 16px;
  padding: 20px 0 0;
  margin: 0;
  padding: 0;
  text-shadow: 1px 1px 0 #fff, -1px -1px 0 #fff, -1px 1px 0 #fff,
    1px -1px 0 #fff, 0px 1px 0 #fff, 0-1px 0 #fff, -1px 0 0 #fff, 1px 0 0 #fff;
}
</style>